import { Card } from '@app/components/various/Card';
import { isDefined } from '@app/utils/is';
import { Row } from '@tanstack/react-table';
import { Invoice } from '@typings';

interface Props {
  row?: Row<Invoice.InvoiceItem>;
}

export const InvoiceItemCard = ({ row }: Props) => {
  if (!isDefined(row)) {
    return null;
  }

  return (
    <Card.Wrapper>
      <div>
        <div className="line-clamp-2 text-neutral-20 body-1">{row.original.name}</div>
        <div className="text-neutral-40 body-4">{row.original.SKU}</div>
      </div>
      <Card.SummaryList>
        <Card.Summary name="Quantity" value={row.original.quantity} />
        <Card.Summary name="Units price" value={row.original.unitPrice} />
        <Card.Summary name="Subtotal" value={row.original.subtotal} />
      </Card.SummaryList>
    </Card.Wrapper>
  );
};
